import React from 'react';
import PropTypes from 'prop-types';
import { track } from '../modules/tracking';
import { SiteNav } from '.';
import {
    LOOP,
    FACEBOOK,
    TWITTER,
    INSTAGRAM,
    SNAPCHAT,
    YOUTUBE,
    SPOTIFY,
    COPYRIGHT,
    PRIVACY_POLICY
} from '../modules/constants';

/**
 * Display all information for the footer. Uses the SiteNav component.
 *
 * @function
 * @constructor
 */
function Footer({ market }) {
    const privacyPolicyLink =
        market === 'UK'
            ? 'https://www.nandos.co.uk/privacy-policy'
            : 'https://www.nandos.ie/privacy-policy';
    return (
        <footer>
            <SiteNav style='footer' market={market} />
            <div className='bottom'>
                <h4>{LOOP}</h4>
                <ul>
                    <li>
                        <a
                            target='_blank'
                            rel='noreferrer'
                            className='fb'
                            href='https://www.facebook.com/Nandos.UnitedKingdom'
                            onClick={track(
                                `Footer: Click: Open: ${FACEBOOK} link`
                            )}
                        >
                            {FACEBOOK}
                        </a>
                    </li>
                    <li>
                        <a
                            target='_blank'
                            rel='noreferrer'
                            className='tw'
                            href='https://twitter.com/NandosUK'
                            onClick={track(
                                `Footer: Click: Open: ${TWITTER} link`
                            )}
                        >
                            {TWITTER}
                        </a>
                    </li>
                    <li>
                        <a
                            target='_blank'
                            rel='noreferrer'
                            className='ig'
                            href='http://instagram.com/nandosuk'
                            onClick={track(
                                `Footer: Click: Open: ${INSTAGRAM} link`
                            )}
                        >
                            {INSTAGRAM}
                        </a>
                    </li>
                    <li>
                        <a
                            target='_blank'
                            rel='noreferrer'
                            className='sc'
                            href='https://www.snapchat.com/add/nandosuk'
                            onClick={track(
                                `Footer: Click: Open: ${SNAPCHAT} link`
                            )}
                        >
                            {SNAPCHAT}
                        </a>
                    </li>
                    <li>
                        <a
                            target='_blank'
                            rel='noreferrer'
                            className='yt'
                            href='https://www.youtube.com/channel/UCVgYYZS_7RE-Hh9dFVMo8Rw'
                            onClick={track(
                                `Footer: Click: Open: ${YOUTUBE} link`
                            )}
                        >
                            {YOUTUBE}
                        </a>
                    </li>
                    <li>
                        <a
                            target='_blank'
                            rel='noreferrer'
                            className='sp'
                            href='https://play.spotify.com/user/nandosuk'
                            onClick={track(
                                `Footer: Click: Open: ${SPOTIFY} link`
                            )}
                        >
                            {SPOTIFY}
                        </a>
                    </li>
                </ul>
                {COPYRIGHT} {new Date().getFullYear()} |{' '}
                <a
                    onClick={track(
                        `Footer: Click: Open: ${PRIVACY_POLICY} link`
                    )}
                    href={privacyPolicyLink}
                >
                    {PRIVACY_POLICY}
                </a>
            </div>
        </footer>
    );
}

Footer.propTypes = {
    market: PropTypes.string
};

export { Footer };
